module.exports = __webpack_public_path__ + "img/bg.d22050ea.webp";